var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"grey lighten-2"}},[_c('v-card-title',{staticClass:"d-flex align-center justify-space-between"},[_c('div',{staticClass:"text-h5 font-weight-medium"},[_vm._v("Suas Informações")])]),_c('v-divider'),_c('v-card-text',{staticClass:"mt-2"},[_c('InCharge'),_c('BasicData'),_c('EditAddress'),_c('ChangePassword')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }